import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import appReducer from './appSlice';
import userReducer from './userSlice';
import patientReducer from './patientSlice';
import customerReducer from './customerSlice';
import layoutsSlice from './layoutsSlice';
import customFormReducer from './customFormSlice';
import workListReducer from './workListSlice';
import formularyReducer from './formularySlice';
import productReducer from './productSlice';
import woundReportReducer from './woundReportSlice';
import usageAnalyticsReportReducer from './usageAnalyticsReportSlice';
import uiReducer from './uiSlice';
import menuReducer from './menuSlice';
import homeReducer from './homeSlice';
import ssoConfigReducer from './ssoConfigSlice';
import { injectStore } from './storeAccessor';

const rootReducer = combineReducers({
  app: appReducer,
  home: homeReducer,
  ui: uiReducer,
  menu: menuReducer,
  user: userReducer,
  patient: patientReducer,
  customer:customerReducer,
  layouts:layoutsSlice,
  forms:customFormReducer,
  worklists:workListReducer,
  formulary: formularyReducer,
  product: productReducer,
  woundreport:woundReportReducer,
  usageAnalyticsReport:usageAnalyticsReportReducer,
  ssoConfig: ssoConfigReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: {
      warnAfter: 150
    }
  })
})

injectStore(store);
